import React from 'react';
import { MessageDescriptor, FormattedMessage } from 'react-intl';

import './MarketTitle.scss';

function renderName(name: string) {
    // TODO: remove hardcode 1x2
    const isOneXTwo = name.toLocaleLowerCase() === '1x2';

    return (
        <div styleName="name" className="__app-MarketTitle-name" title={name}>
            {isOneXTwo ? (
                name.split('').map(letter => <div key={letter}>{letter}</div>)
            ) : (
                <div styleName="ellipsis">{name}</div>
            )}
        </div>
    );
}

interface OwnProps {
    name: string;
    defaultMsg: MessageDescriptor;
}

export default function MarketTitle(props: OwnProps) {
    const { name, defaultMsg } = props;

    return name ? (
        renderName(name)
    ) : (
        <FormattedMessage {...defaultMsg}>
            {(txt: string) => renderName(txt)}
        </FormattedMessage>
    );
}
